/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <div class="auth-container">
        <form @submit.prevent="handleReset" class="auth-form">
            <h2>Crear nueva contraseña</h2>
            
            <label>Nueva Contraseña</label>
            <input 
                type="password" 
                placeholder="Mínimo 8 caracteres" 
                v-model="password"
                required 
                minlength="8"
                :disabled="isLoading || success"
            />

            <label>Confirmar Contraseña</label>
            <input 
                type="password" 
                placeholder="Repite la contraseña" 
                v-model="confirmPassword"
                required 
                :class="{ 'input-error': passwordMismatch }"
                :disabled="isLoading || success"
            />
            
            <p v-if="passwordMismatch" class="error-message">Las contraseñas no coinciden.</p>
            <p v-if="serverError" class="error-message">{{ serverError }}</p>
            
            <div v-if="success" class="success-message">
                <p>¡Contraseña actualizada correctamente!</p>
                <p style="font-size: 12px; margin-top: 5px;">Redirigiendo al login...</p>
            </div>

            <button type="submit" :disabled="botonDeshabilitado">
                {{ isLoading ? 'Actualizando...' : 'Guardar Nueva Contraseña' }}
            </button>
        </form>
    </div>
</template>

<script>
import userService from '@/services/userService'; 

export default {
    name: 'RestablecerPassword',
    data() {
        return {
            password: '',
            confirmPassword: '',
            isLoading: false,
            serverError: '',
            success: false
        };
    },
    computed: {
        passwordMismatch() {
            return this.password && this.confirmPassword && this.password !== this.confirmPassword;
        },
        botonDeshabilitado() {
            return this.isLoading || this.success || this.passwordMismatch || !this.password;
        }
    },
    methods: {
        async handleReset() {
            if (this.passwordMismatch) return;

            this.isLoading = true;
            this.serverError = '';

            const { uid, token } = this.$route.params;

            try {
                await userService.confirmPasswordReset(uid, token, this.password);
                
                this.success = true;
                this.password = '';
                this.confirmPassword = '';

                setTimeout(() => {
                    this.$router.push('/login'); 
                }, 3000);

            } catch (err) {
                console.error("Error al restablecer:", err);
                if (err.response && err.response.data && err.response.data.error) {
                    this.serverError = err.response.data.error; 
                } else {
                    this.serverError = 'El enlace ha expirado o es inválido. Solicita uno nuevo.';
                }
            } finally {
                if (!this.success) this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.auth-container { display: flex; justify-content: center; align-items: center; height: 100vh; } 
.auth-form { width: 80%; max-width: 400px; display: flex; flex-direction: column; margin: 0 auto; }

h2 { text-align: center; color: #333; margin-bottom: 20px; }
label { font-size: 16px; margin-top: 15px; font-weight: 600; color: #555; }
input { padding: 10px; margin-top: 5px; border: 1px solid #ccc; border-radius: 10px; font-size: 14px; height: 35px; }

input:focus { outline: none; border-color: #29b9f6; }
input:disabled { background-color: #f0f0f0; cursor: not-allowed; }

button { width: 100%; background: #29b9f6; color: white; border: none; padding: 12px; margin-top: 30px; cursor: pointer; border-radius: 5px; font-size: 16px; font-weight: bold; transition: 0.3s ease; }
button:hover { background: #247a9e; }
button:disabled { background-color: #8bbdd3; cursor: not-allowed; }

.input-error { border: 2px solid red; }
.error-message { color: red; font-size: 14px; margin-top: 5px; }

.success-message {
    text-align: center;
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    padding: 15px;
    margin-top: 20px;
    border-radius: 5px;
    border: 1px solid transparent;
}
</style>